import { render } from "./story_publication.vue?vue&type=template&id=0d88bd1c&scoped=true&lang=pug"
import script from "./story_publication.vue?vue&type=script&lang=js"
export * from "./story_publication.vue?vue&type=script&lang=js"

import "./story_publication.vue?vue&type=style&index=0&id=0d88bd1c&scoped=true&lang=css"

import exportComponent from "../../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d88bd1c"]])

export default __exports__